import React from "react";
const xOffSet = 10;
const yOffSet = 10;
const DeleteContextMenu = ({ x, y, onDelete, onClose }) => {
  return (
    <div
      style={{ top: y + yOffSet, left: x + xOffSet }}
      className="absolute z-50"
      onMouseLeave={onClose}
    >
      <ul
        onClick={onDelete}
        className="text-xs menu bg-base-200 border-black rounded-sm hover:bg-base-300 hover:cursor-pointer px-8"
      >
        <li>Delete Graphic</li>
      </ul>
    </div>
  );
};

export default DeleteContextMenu;
